import CurriculumTemplateHeader from './CurriculumTemplateHeader';

export default CurriculumTemplateHeader;
